<template>
    <div class="login-form-wrap">
        <div class="tab-container">
            <div class="tab-placefixed" ref="fixed">
                <div class="tab-wrap-login">
                    <div class="tab">
                        <a v-for="(value,index) in tabs" :class="classFilter(index)" :key="index" href="javascrit:;"  @click.prevent="tabChange(index)">{{value}}</a>
                    </div>
                </div>
            </div>
            <div class="pr">
               <form-pwd v-show="tabShowCode" />
               <form-code v-show="!tabShowCode" />
                <div class="btndoc" v-if="doclist" @click="goList">返回医生列表</div>
            </div>
        </div>
         
    </div>
</template>

<script>
import formPwd from "./form-pwd.vue";
import formCode from "./form-code.vue";

export default {
    props:{
        isPopup:{
            type:Boolean,
            default:false
        }
    },
   data(){
        return {
            tabs:[
               "登录/注册",
               "密码登录"
            ],
            tabShowCode:false,
            currentIndex:0,
            doclist:false
        }
    },
    methods:{
       classFilter(index){
            return index===this.currentIndex?"on":"";
       },
       tabChange(index){
           if(this.currentIndex===index)return;
           this.tabShowCode =index===1;
           this.currentIndex=index;
       },
       goList(){
        this.$router.push('/doclist');
       }
    },
    created(){
        var tab=this.$route.params.tab;
        this.currentIndex=tab==="code"?1:0;
       this.doclist=this.$route.query.docList;
    },
    components:{
        formPwd,
        formCode
    }
};
</script>

<style>
.login-form-wrap{margin:5%;}
.login-form-wrap>.tab-wrap{border-bottom-color:transparent;}
.login-form-wrap .tab{height:auto;line-height:3;text-align:center;margin-bottom:1em;}
.login-form-wrap .tab>a.on:after{left:0;width:100%;margin-left:0;}
.login-form-wrap>.tab-container{padding-bottom:0;}
.tab>a{height:3em;font-size:.44rem;}
.btndoc{
  font-size: 6.656px;
    font-size: 0.416rem;
    height: 2.8em;
    line-height: 2.8em;
    color: #00b38b;
    border: 1px solid #00b38b;
    border-radius: 1.5em;
    text-align: center;
    background-color: #FFF;
    cursor: pointer;
    outline: none;
    margin-top: 0.533333rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/view.vue